import { lockBody, unlockBody } from '../helpers/lockBody';
import { debounce, assign } from 'lodash';
import { enableTabbableChildren } from "../helpers/enableTabbableChildren";
import { disableTabbableChildren } from "../helpers/disableTabbableChildren";
import { BasicButtonToggling } from '../helpers/basic-button-toggling';

// Static strings
const openMenuClasses = ['open'];
const navLoadedClass = 'mheader-has-loaded';
const navId = "navigationContainer";
const menuId = "navControl";

export class MainNavigation extends BasicButtonToggling{
    container: HTMLElement;
    menuTrigger: HTMLButtonElement;
    menuCloseTrigger: HTMLButtonElement;
    menuPanel: HTMLElement;
    menuFocusableChildren: Array<HTMLButtonElement | HTMLAnchorElement | HTMLInputElement>;
    menuIsOpen: boolean;
    navIsShowing: boolean;
    existingBodyStyles: string;
    lastScrollPosition: number;
    hasLoaded: boolean;
    currentNavHeight: number;
    bodyEl: HTMLBodyElement;
    onPageAnchorLinks: HTMLAnchorElement[];
    navSearchCloseBtn: null | HTMLElement;
    subNavButtons: HTMLButtonElement[];
    constructor(navigation: HTMLElement) {
        super();
        this.container = navigation;
        this.menuPanel = document.querySelector(`#${menuId}`) as HTMLElement;
        this.menuTrigger = this.menuPanel.querySelector(`[aria-controls="${navId}"]`) as HTMLButtonElement;
        this.menuCloseTrigger = this.container.querySelector("#mnavCloser") as HTMLButtonElement;
        this.menuFocusableChildren = [].slice.call(this.menuPanel.querySelectorAll('button, a, input'));
        this.bodyEl = document.body as HTMLBodyElement;
        this.menuIsOpen = false;
        this.navIsShowing = true;
        this.hasLoaded = false;
        this.existingBodyStyles = '';
        this.navSearchCloseBtn = null;
        this.subNavButtons = Array.from(document.querySelectorAll('[data-parent-button]'));


        window.addEventListener(
            'resize',
            debounce(() => {
                this.closeMenuOnResize();
            }, 100)
        );

    }

    init = () => {
        console.log('awasd')
        this.menuTrigger.addEventListener('click', () => {
            this.openMenu();
        });

        this.menuCloseTrigger.addEventListener('click', () => {
            this.closeMenu();
        });

     
        document.body.addEventListener('keyup', (e: KeyboardEvent) => {
            if (e.which == 27 && this.menuIsOpen) { // Escape key
                this.closeMenu();
                this.menuTrigger.focus();
            }
            if (e.which == 9) { // Tab key. Show nav if tabbed into, or close menu if tabbed out of.
                const focusInNav = this.menuPanel.contains(document.activeElement) || this.container.contains(document.activeElement);
                if (!focusInNav && this.menuIsOpen) {
                    this.closeMenu();
                }
            }
        });

        // Setup on page load
        this.closeMenu();
        this.setPageOffset();
        this.activateSubNavButtons();
    }

    activateSubNavButtons() {
        this.subNavButtons.forEach(button => {
            button.addEventListener("click", this.handleSubMenuClick, false);
            this.updateAriaExpanded(button, 'false');
        });
    }

    openMenu = () => {
        this.bodyEl.classList.add('nav-open');
        this.menuPanel.setAttribute('aria-hidden', 'false');
        this.menuTrigger.setAttribute('aria-expanded', 'true');
        this.enableTabbableChildren();
        this.menuIsOpen = true;
        this.existingBodyStyles = lockBody();
        openMenuClasses.forEach(cssClass => {
            this.container.classList.add(cssClass);
            this.menuPanel.classList.add(cssClass);
        });
    }


    closeMenu = () => {
        this.bodyEl.classList.remove('nav-open');
        this.menuPanel.setAttribute('aria-hidden', 'true');
        this.menuTrigger.setAttribute('aria-expanded', 'false');
        this.disableTabbableChildren();
        this.menuIsOpen = false;
        unlockBody(this.existingBodyStyles);
        openMenuClasses.forEach(cssClass => {
            this.container.classList.remove(cssClass);
            this.menuPanel.classList.remove(cssClass);
        });
        this.setPageOffset();
    }

    enableTabbableChildren = () => {
        this.menuFocusableChildren.forEach(child => {
            child.tabIndex = 0;
        })
    }

    disableTabbableChildren = () => {
        this.menuFocusableChildren.forEach(child => {
            child.tabIndex = -1;
        })
    }

    setPageOffset = () => {
        if (!this.hasLoaded) {
            this.container.classList.add(navLoadedClass);
            this.hasLoaded = true;
        }
        this.currentNavHeight = this.container.offsetHeight;

    }

    resizeHandler = () => {
        this.setPageOffset();
    }

    closeMenuOnResize = () => {
        const mediaQuery = window.matchMedia('(min-width: 1024px)')
        if (mediaQuery.matches) {
            if (this.isTheMenuOpen) {
                this.closeMenu();
            }
        }
    }

    get isTheMenuOpen() {
        return this.menuIsOpen;
    }

    handleSubMenuClick = (e: Event) => {
        e.stopPropagation();
        this.toggleSubNav(e.target as HTMLButtonElement, e);
    }
    toggleSubNav(button: HTMLButtonElement, e: Event) {
        const currentStatus = button.getAttribute('aria-expanded');
        this.handleClick(e);
    }
  
}

let mainNavigation: MainNavigation = null;
const navContainer = document.querySelector(`#${navId}`) as HTMLElement;
if (navContainer) {
    mainNavigation = new MainNavigation(navContainer);
    (window as any).mainNavigation = mainNavigation;
}
export { mainNavigation };